import { BaseApiService } from '@doccareplus/api-client';

export interface NotificationItem {
  id: string;
  type: string;
  title: string;
  body: string;
  deepLink?: string | null;
  targetReference?: string | null;
  isRead: boolean;
  createdAt: string;
}

export interface NotificationListResponse {
  items: NotificationItem[];
  nextCursor?: string | null;
}

export interface UnreadNotificationCountResponse {
  count: number;
}

class NotificationApiService extends BaseApiService {
  constructor() {
    super('/clinic/notifications');
  }

  list(cursor?: string, limit = 20): Promise<NotificationListResponse> {
    return this.get<NotificationListResponse>('', { params: { cursor, limit } });
  }

  unreadCount(): Promise<UnreadNotificationCountResponse> {
    return this.get<UnreadNotificationCountResponse>('/unread-count');
  }

  markRead(notificationId: string): Promise<UnreadNotificationCountResponse> {
    return this.post<UnreadNotificationCountResponse>(`/${notificationId}/read`);
  }

  markAllRead(): Promise<UnreadNotificationCountResponse> {
    return this.post<UnreadNotificationCountResponse>('/read-all');
  }
}

export const notificationsApi = new NotificationApiService();
